import { Component, Input } from '@angular/core';

@Component({
  selector: 'icon-bell-filled',
  imports: [],
  templateUrl: './icon-bell-filled.component.html',
  styles: `
    .bell-filled-icon {
      transition: transform 0.2s ease-in-out;
    }
    
    .bell-filled-icon:hover {
      transform: scale(1.1);
    }

    .bell-filled-icon.animate-bounce {
      animation: bounce 0.6s ease-in-out;
    }

    @keyframes bounce {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.2); }
    }
  `
})
export class IconBellFilledComponent {
  @Input() size: number = 24;
}
